import React from "react";

import { FormattedMessage } from "react-intl";
import { connect } from "shared/src/stores/storeConnect";
import SearchResultStore from "../../../stores/SearchResultStore";
import ContentSearchStore from "../../../stores/ContentSearchStore";

type Props = {
    onTabClick: (tab: number) => void;
    activeTab: number;
    articleSearchResultState: {
        amount: number;
        loading: boolean;
    };
    contentSearchResultState: {
        amount: number;
        loading: boolean;
    };
};

function SearchTabs(props: Props) {
    return (
        <div className="mfcss_pageheader--tabs">
            <ul className="nav nav-tabs">
                <li className={props.activeTab === 0 ? "active" : ""}>
                    <a onClick={() => props.onTabClick(0)}>
                        <FormattedMessage id="EX_SEARCH_TAB_ARTICLES" />
                        &nbsp;
                        <span>
                            (
                            {props.articleSearchResultState.loading ? (
                                <i className="icon-spinner" />
                            ) : (
                                props.articleSearchResultState.amount
                            )}
                            )
                        </span>
                    </a>
                </li>
                <li className={props.activeTab === 1 ? "active" : ""}>
                    <a onClick={() => props.onTabClick(1)}>
                        <FormattedMessage id="EX_SEARCH_TAB_INSPIRATION" />
                        &nbsp;
                        <span>
                            (
                            {props.contentSearchResultState.loading ? (
                                <i className="icon-spinner" />
                            ) : (
                                props.contentSearchResultState.amount
                            )}
                            )
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    );
}

const wrapped = connect(
    {
        stores: [
            [
                SearchResultStore,
                (s: typeof SearchResultStore) => ({
                    articleSearchResultState: {
                        amount: s.getState()?.result?.amount ?? 0,
                        loading: s.getState()?.searchRunning ?? false
                    }
                })
            ],
            [
                ContentSearchStore,
                (s: typeof ContentSearchStore) => ({
                    contentSearchResultState: {
                        amount: s.getState()?.numFound ?? 0,
                        loading: s.getState()?.loading ?? false
                    }
                })
            ]
        ]
    },
    SearchTabs
);
export default wrapped;
